// Good Grains Mock Data

export const products = [
  {
    id: 1,
    name: "Non-GMO Super Layer Grain",
    description: "Complete Feed for Laying Hens 17% Protein",
    price: 25.00,
    totePrice: 395.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/yyecxcow_IMG_2819.jpeg",
    category: "poultry"
  },
  {
    id: 2,
    name: "Non-GMO Layer Grain (LP)",
    description: "Complete Feed for Laying Hens 12% Protein",
    price: 22.00,
    totePrice: 375.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/left0z7k_IMG_8362.jpeg",
    category: "poultry"
  },
  {
    id: 3,
    name: "Non-GMO Chick Grower Grain",
    description: "Complete Feed for Broilers 20% Protein",
    price: 26.00,
    totePrice: 420.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/j80o7h79_IMG_2783.jpeg",
    category: "poultry"
  },
  {
    id: 4,
    name: "Non-GMO Scratch Grains",
    description: "Healthy scratch supplement treat for chickens",
    price: 20.00,
    totePrice: null,
    bagSize: "50 lb bag",
    toteSize: null,
    image: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=500&auto=format&fit=crop",
    category: "poultry"
  },
  {
    id: 5,
    name: "Non-GMO All Stock Grain",
    description: "Complete Feed for Beef Cattle, Horses, Sheep & Goats 14% Protein",
    price: 22.00,
    totePrice: 360.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/1vky2kt1_IMG_2839.jpeg",
    category: "livestock"
  },
  {
    id: 6,
    name: "Non-GMO Swine Grower Grain",
    description: "Complete Feed for Growing & Finishing Swine 14% Protein",
    price: 22.00,
    totePrice: 360.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/d2cqccsu_FullSizeRender.jpeg",
    category: "swine"
  },
  {
    id: 7,
    name: "Non-GMO Dairy Supplement",
    description: "16% Protein, Vitamin & Mineral Supplement for Milking Cows, Goats and Sheep",
    price: 25.00,
    totePrice: 380.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/yqcypf12_IMG_2886.jpeg",
    category: "supplements"
  },
  {
    id: 8,
    name: "Non-GMO Equine Feed",
    description: "Premium Feed for Horses 14% Protein - Good for Senior Maintenance",
    price: 24.00,
    totePrice: 380.00,
    bagSize: "50 lb bag",
    toteSize: "1000 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/hu4tuq7m_IMG_2887.jpeg",
    category: "equine"
  },
  {
    id: 10,
    name: "Cracked Corn",
    description: "A good energy supplement for livestock and poultry diets",
    price: 20.00,
    totePrice: null,
    bagSize: "50 lb bag",
    toteSize: null,
    image: "https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=500&auto=format&fit=crop",
    category: "supplements"
  },
  {
    id: 11,
    name: "Garbanzo Beans & Field Peas",
    description: "High protein, cracked open supplement to add to your feeding routine - Available mixed or unmixed",
    price: 20.00,
    totePrice: null,
    bagSize: "50 lb bag",
    toteSize: null,
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/3j8dppnw_image.jpeg",
    category: "supplements"
  },
  {
    id: 12,
    name: "Non-GMO, Un-Sprayed Alfalfa Pellets",
    description: "Protein supplement for rabbits, horses, cows, goats, and sheep",
    price: 20.00,
    totePrice: 285.00,
    bagSize: "40 lb bag",
    toteSize: "850 lb tote",
    image: "https://customer-assets.emergentagent.com/job_prairie-grains/artifacts/9vfls06d_image.png",
    category: "supplements"
  }
];

export const feedCategories = [
  {
    id: 1,
    name: "Poultry Feed",
    description: "Layer feed, broiler feed, chick grower grain",
    image: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=600&auto=format&fit=crop"
  },
  {
    id: 2,
    name: "Dairy & Livestock Feed",
    description: "For cows, goats, and other grazing animals",
    image: "https://images.unsplash.com/photo-1527153857715-3908f2bae5e8?w=600&auto=format&fit=crop"
  },
  {
    id: 3,
    name: "Swine Feed",
    description: "Feed for growing and finishing pigs",
    image: "https://images.unsplash.com/photo-1516467508483-a7212febe31a?w=600&auto=format&fit=crop"
  },
  {
    id: 4,
    name: "Supplements",
    description: "Supports healthy digestion, milk production, and vitality",
    image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=600&auto=format&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    text: "We've been really happy working with Good Grains here at Rainy Roots Farm. The 1,000-pound tote option has made a big difference for us — it's practical, efficient, and works well for a growing farm like ours. Our livestock have done really well on the feed, and that's what matters most to us. We're grateful to have a local feed supplier we trust and would gladly recommend Good Grains to other farms.",
    author: "Mark L.",
    location: "Whitefish, MT",
    featured: true
  },
  {
    id: 2,
    text: "Delivery was quick, and the feed quality is top-notch.",
    author: "Emily R.",
    location: "Kalispell, MT",
    featured: false
  },
  {
    id: 3,
    text: "Our chickens have never looked better since switching to Good Grains LLC.",
    author: "Jenny T.",
    location: "Whitefish, MT",
    featured: false
  },
  {
    id: 4,
    text: "Our cows love it, and I feel confident giving them something organic and non-GMO. Highly recommend!",
    author: "Local Farmer",
    location: "Montana",
    featured: false
  }
];

export const valueProps = [
  {
    id: 1,
    title: "All Types of Animal Feed",
    description: "Organic and non-GMO feed, balanced supplements, and natural ingredients, all selected with your animals' well-being in mind.",
    icon: "wheat"
  },
  {
    id: 2,
    title: "Reliable Service",
    description: "Local delivery drop-off locations (around Kalispell, Montana and nearby areas), easy pickup, and quick responses whenever you need us.",
    icon: "truck"
  },
  {
    id: 3,
    title: "Experienced Team",
    description: "Real people who know animals and farms, ready to help you make the right choices.",
    icon: "users"
  },
  {
    id: 4,
    title: "Genuine Relationships",
    description: "We build lasting connections with our customers because we care about your animals and your farm.",
    icon: "heart"
  },
  {
    id: 5,
    title: "Quality Feed You Can Trust",
    description: "Organic & Non-GMO feed and wholesome supplements for all your animals.",
    icon: "shield"
  },
  {
    id: 6,
    title: "Community-Focused",
    description: "Supporting homesteads, small or big farms, and local farmers is at the heart of everything we do.",
    icon: "home"
  }
];

export const faqItems = [
  {
    id: 1,
    question: "What types of feed does Good Grains offer?",
    answer: "We offer both organic and non-GMO animal feed. Customers can choose what works best for their animals and farming goals. All our feed is pasture-grown and made with quality nutrition in mind."
  },
  {
    id: 2,
    question: "Which animals is your feed suitable for?",
    answer: "Our feed is commonly used for chickens, goats, cattle, pigs, sheep, poultry, horses, rabbits, and more. If you're unsure whether a specific feed is right for your animals, we're happy to help you decide."
  },
  {
    id: 3,
    question: "What's the difference between organic and non-GMO feed?",
    answer: "Organic feed is grown following certified organic practices and avoids synthetic chemicals. Non-GMO feed uses grains that are not genetically modified but may not be certified organic. Both options provide natural, wholesome nutrition. The choice depends on your preferences and needs."
  },
  {
    id: 4,
    question: "Where does Good Grains source its feed?",
    answer: "We source our grains from trusted producers in Northern Idaho, and Central Montana."
  },
  {
    id: 5,
    question: "How long have you been in business?",
    answer: "We are a new startup since May of 2025. We took over the business from Michelle Dilsaver of Holy Cross Farms, which had been in business for over 5 years. We work closely with farmers, homesteaders, and animal owners who care about what they feed their animals."
  },
  {
    id: 6,
    question: "Do you help customers choose the right feed?",
    answer: "Yes. We offer personalized, practical guidance to help you select the right feed based on your animals, their stage of growth, and your goals — whether that's egg production, milk, weight gain, or general health."
  },
  {
    id: 7,
    question: "Do you offer delivery?",
    answer: "We offer local delivery and are currently catering to Kalispell, Montana, and the surrounding areas."
  },
  {
    id: 8,
    question: "Is your feed suitable for backyard farms and small homesteads?",
    answer: "Absolutely. We work with backyard flocks, small farms, growing farms and larger farms. No setup is too small. If you care about quality feed, we're happy to serve you."
  },
  {
    id: 9,
    question: "Why should I choose Good Grains for my animals?",
    answer: "You should choose Good Grains because we put quality, care, and community first. Our feed is local, organic, and non-GMO, giving your animals wholesome nutrition you can trust. We also offer practical support and personal service that big-box stores just can't match — whether you have a backyard flock, a small farm, or a larger operation, we're here to help your animals thrive."
  },
  {
    id: 10,
    question: "How can I place an order or ask a question?",
    answer: "You can call or text us at 406-607-2302. Email us at Robert@goodgrainsmt.com, or make an appointment to visit at 1185 Majestic View Lane, Kalispell, MT 59901. We're always ready and happy to help."
  },
  {
    id: 11,
    question: "What are your business hours and days?",
    answer: "Monday – Saturday: 9:00 AM – 6:00 PM. Sunday: Closed."
  }
];

export const contactInfo = {
  address: "1185 Majestic View Lane, Kalispell, Montana 59901",
  phone: "406-607-2302",
  email: "Robert@goodgrainsmt.com",
  hours: {
    weekdays: "Monday–Saturday: 9:00 AM – 6:00 PM",
    sunday: "Sunday: Closed"
  },
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    tiktok: "https://tiktok.com"
  }
};
